import React from 'react'
import {useState, useEffect} from 'react'
import { getTimeUntil, getTimeSince } from '../helpers/DateHelpers'

function pad(num, size) {
    num = num.toString()
    while (num.length < size) num = "0" + num
    return num
}

export default function CallTimer({conferenceStartDate, conferenceEndDate}) {
  const [startDateTime] = useState(new Date())
  const [tick, setTick] = useState(1)
  const [timer, setTimer] = useState({hours: 0, minutes: 0, seconds: 0})
  const [countdownTimer, setCountdownTimer] = useState({hours: 0, minutes: 0, seconds: 0})
  const [isTimedConference, setIsTimedConference] = useState(false)
  const [isEndingSoon, setIsEndingSoon] = useState(false)
  const [hasOverrun, setHasOverrun] = useState(false)

  useEffect(() => {
    const interval = setInterval(() => {
        setTick(new Date());
    }, 1000);
    return () => clearInterval(interval)
  }, [])

  useEffect(() => {
    conferenceEndDate ? setIsTimedConference(true) : setIsTimedConference(false)
  }, [conferenceEndDate])

  useEffect(() => {
    const t = getTimeSince(startDateTime)
    setTimer({hours: t.hours, minutes: t.minutes, seconds: t.seconds})
    var ct = getTimeUntil(conferenceEndDate)
    if (ct.total < 300000) setIsEndingSoon(true)
    if (ct.total < 0) {
        setHasOverrun(true)
        ct = getTimeSince(conferenceEndDate)
    }
    setCountdownTimer({hours: ct.hours, minutes: ct.minutes, seconds: ct.seconds})
  }, [tick, startDateTime, conferenceEndDate])

  const renderTimer = () => {
    return (
        <div
            className='live-call-call-timer-timer'
        >
            {pad(timer.hours,2)}:{pad(timer.minutes,2)}:{pad(timer.seconds,2)}
        </div>
    )
  }

  const renderCountdownTimer = () => {
    return (
        <div 
            className={`live-call-call-timer-timer${isEndingSoon ? ' live-call-call-timer-timer-ending' : ''}`}
            >
            {hasOverrun ? '+ ' : ''}{pad(countdownTimer.hours,2)}:{pad(countdownTimer.minutes,2)}:{pad(countdownTimer.seconds,2)}
        </div>
    )
  }

  return (
    <div>
        {isTimedConference ? renderCountdownTimer() : renderTimer()}
    </div>
  )
}
